import { Tooltip } from '@audio-network/componentlibrary'
import { Star, StarFilled } from '@audio-network/componentlibrary/icons'
import clsx from 'clsx'
import { useTranslation } from 'next-i18next'
import { useState } from 'react'

import useFavouritesStore from '@/stores/favouritesStore'
import sessionStore from '@/stores/sessionStore'
import { redirectToHref } from '@/utils/window'

import styles from './FavouriteButton.module.css'
import { FavouriteButtonProps } from './FavouriteButton.types'

const FavouriteButton = ({
	className,
	source,
	track,
}: FavouriteButtonProps): JSX.Element => {
	const user = sessionStore((state) => state.session?.user)
	const favouriteTracks = useFavouritesStore((state) => state.favouriteTracks)
	const toggleFavourite = useFavouritesStore((state) => state.toggleFavourite)

	const isFavourite = !!favouriteTracks?.some(
		(favouriteTrack) => favouriteTrack === track.id
	)

	const [shouldBounce, setShouldBounce] = useState(false)

	const { t } = useTranslation(['trackrow'])

	const handleClick = (): void => {
		setShouldBounce(true)

		if (!user?.id) {
			redirectToHref(`/login`)
			return
		}

		toggleFavourite(track, source)
	}

	const handleAnimationEnd = (): void => {
		setShouldBounce(false)
	}

	return (
		<Tooltip content={t('track-actions.favourite-track')}>
			<button
				aria-pressed={isFavourite}
				onClick={handleClick}
				className={clsx(styles.button, className)}
				data-favourite={track.id}
			>
				<span
					className={clsx(styles.iconWrapper, shouldBounce && styles.bounce)}
					onAnimationEnd={handleAnimationEnd}
				>
					<Star className={styles.empty} color="ui1" />
					<StarFilled className={clsx(styles.filled)} color="yellow" />
				</span>
			</button>
		</Tooltip>
	)
}

export default FavouriteButton
